"use strict";
var Grammar = require('./Grammar/dist/Grammar');

module.exports = function (SIP) {

return {
  parse: function parseCustom (input, startRule) {
    var options = {startRule: startRule, SIP: SIP};
    try {
      Grammar.parse(input, options);
    } catch (e) {
      options.data = -1;
    }
    return options.data;
  }
};

};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@twilio/sip.js/src/Grammar.js
// module id = 1067
// module chunks = 0